import {PropsWithChildren} from 'react';
import {useSelector} from 'react-redux';
import {Navigate} from 'react-router-dom';
import {getToken} from '../managers/slices/authenticationSlice';

export function PrivateRoute({children}: PropsWithChildren<any>) {
  return useSelector(getToken) ? children : <Navigate to="/login" />;
}
